"use client";

import { PulseAnimation, Stack, Text } from "@leabankab/component-library";

type Props = {
	text: string;
	title?: string;
	minHeight?: string | number;
	fullHeight?: boolean;
};

export const BrandLoadingState = ({
	text,
	title,
	minHeight = "60vh",
	fullHeight = false,
}: Props) => (
	<Stack
		style={{
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			minHeight,
			height: fullHeight ? "80vh" : undefined,
			gap: 2,
			padding: 3,
			textAlign: "center",
		}}
	>
		<PulseAnimation />
		<Stack direction="column" aria-live="polite" gap={1}>
			{title && (
				<Text
					render={<h1 />}
					textStyle="heading-md"
					fontWeight="medium"
					color="text.base"
					align="center"
				>
					{title}
				</Text>
			)}
			<Text
				render={<p />}
				textStyle="body-md"
				color="text.subtle"
				align="center"
			>
				{text}
			</Text>
		</Stack>
	</Stack>
);
